import { Box } from '@mui/material';
import { RegionData } from '@/types/dashboard';
import { RegionalMap } from './RegionalMap';

interface RegionDrillDownProps {
  regionData: Record<string, RegionData>;
  onRegionSelect: (region: string) => void;
}

export function RegionDrillDown({ regionData, onRegionSelect }: RegionDrillDownProps) {
  return (
    <Box sx={{ 
      width: '100%', 
      height: 600,
      display: 'flex',
      flexDirection: 'column',
      '& > *': {
        flex: 1,
      }
    }}>
      <RegionalMap
        regionData={regionData}
        onRegionClick={onRegionSelect}
      />
    </Box>
  );
} 